import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// ehr#420: dark mode, after App so it comes after every stylesheet App pulls in (the overrides win by order)
import './theme-dark.css';
import './theme-dark.generated.css';
import { SessionProvider } from './auth/session.js';
import { UpdateNotice } from './components/UpdateNotice.js';
import { DialogHost } from './lib/dialogs.js';
import { initTheme } from './lib/theme.js';

initTheme(); // ehr#420: this browser's last theme until /auth/me answers

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <SessionProvider>
      <App />
      <DialogHost />
      {/* ehr#480: a tab open across a deploy is told to reload */}
      <UpdateNotice />
    </SessionProvider>
  </StrictMode>,
);
